import React from 'react';

const VisitLink = ({ url, placeholder }) => {
  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="visit-link"
    >
      {placeholder} ↗
    </a>
  );
};

export default React.memo(VisitLink);
